import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.less'],
    standalone: false
})
export class AlertComponent {

  /**
   * Constructor
   */

  constructor(
    public dialogRef: MatDialogRef<AlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {message: string, detail: string, buttons: string[], defaultButton: number},
  ) {}

  /**
   * Methods
   */

  close(result: string): void {
    this.dialogRef.close(this.data.buttons.indexOf(result));
  }

}
